import { render, staticRenderFns } from "./api-document.vue?vue&type=template&id=61acdc3b&"
import script from "./api-document.vue?vue&type=script&lang=js&"
export * from "./api-document.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports